import React, { useEffect } from "react";
import { dateWithoutTimezone } from "../../../utils/dateWithoutTimezone";
import {SectionBox} from "@answersnow/pkg-theme";
import ANFormView from "../../../elements/Forms/ANFormView";
import basicInfoConfig from "./BasicInfoConfig";
import { useGetLanguages } from "hooks/useGetLanguages";

const BasicInfo = ({ basicInfo }) => {
  const [languageNames, setLanguageNames] = React.useState("");

  const { data } = useGetLanguages();
  const languagesData = data?.data || []; // Ensure data is available

  const languages = basicInfo?.languages ?? "";

  useEffect(() => {
    setLanguageNames(
      languages
        .split(",") // Split the id string into an array
        .map((id) => languagesData.find((lang) => lang.id === Number(id))?.name) // Map ids to names
        .filter((name) => name) // Remove undefined values
        .join(", ") // Join into a string
    );
  }, [languagesData]);

  return (
    <SectionBox
      title="Personal Information"
      description={"Personal and contact details"}
      columnDirection
    >
      <ANFormView
        data={{
          firstName: basicInfo?.first_name || "",
          lastName: basicInfo?.last_name || "",
          fullLegalName: basicInfo?.full_legal_name || "",
          email: basicInfo?.email || "",
          phone: basicInfo?.phone || "",
          address1: basicInfo?.street_1 || "",
          address2: basicInfo?.street_2 || "",
          city: basicInfo?.city || "",
          state: basicInfo?.state || "",
          zip: basicInfo?.zip_code || "",
          dateOfBirth: basicInfo?.date_of_birth
            ? dateWithoutTimezone(basicInfo?.date_of_birth)
            : null,
          timezone: basicInfo?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
          gender: basicInfo?.gender || "",
          taxNumber: basicInfo?.last_four ? `XXX-XX-${basicInfo?.last_four}` : "",
          filename: basicInfo?.image_name || "",
          licenseState: basicInfo?.dl_state || "",
          licenseNumber: basicInfo?.state_id_number || "",
          employmentType: basicInfo?.employment_type,
          pronouns: basicInfo?.pronouns,
          languages: languageNames,
        }}
        config={basicInfoConfig}
      ></ANFormView>
    </SectionBox>
  );
};

export default BasicInfo;
